/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choose_PlanInputs */

const en_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a Plan`)
};

const ar_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر خطة`)
};

const de_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen Plan`)
};

const es_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un plan`)
};

const fr_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un plan`)
};

const it_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli un piano`)
};

const ja_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プランを選択`)
};

const ko_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플랜을 선택하세요`)
};

const pt_br_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha um plano`)
};

const ru_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите план`)
};

const th_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกแผน`)
};

const tr_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir Plan Seç`)
};

const zh_cn_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择方案`)
};

const zh_tw_choose_plan = /** @type {(inputs: Choose_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇方案`)
};

/**
* | output |
* | --- |
* | "Choose a Plan" |
*
* @param {Choose_PlanInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const choose_plan = /** @type {((inputs?: Choose_PlanInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choose_PlanInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_choose_plan(inputs)
	if (locale === "ar") return ar_choose_plan(inputs)
	if (locale === "de") return de_choose_plan(inputs)
	if (locale === "es") return es_choose_plan(inputs)
	if (locale === "fr") return fr_choose_plan(inputs)
	if (locale === "it") return it_choose_plan(inputs)
	if (locale === "ja") return ja_choose_plan(inputs)
	if (locale === "ko") return ko_choose_plan(inputs)
	if (locale === "pt_br") return pt_br_choose_plan(inputs)
	if (locale === "ru") return ru_choose_plan(inputs)
	if (locale === "th") return th_choose_plan(inputs)
	if (locale === "tr") return tr_choose_plan(inputs)
	if (locale === "zh_cn") return zh_cn_choose_plan(inputs)
	return zh_tw_choose_plan(inputs)
});